/* eslint-disable max-statements */
import serverData from './server-data'
import clientLogger from './client-logger'
import { getApplicationTypeName } from './common-utils'

function recordFpti(type, payload) {
  const analytics = window?.PAYPAL?.analytics
  const instance =
    analytics?.instance || analytics?.AnalyticsInstance || analytics

  const methodName = type === 'click' ? 'recordClick' : 'recordImpression'
  const recordFn = instance && instance[methodName]

  if (typeof recordFn === 'function') {
    try {
      recordFn.call(instance, { data: payload })
      return
    } catch (error) {
      clientLogger.warn(
        `FPTI ${type} retrying with raw payload: ${
          error?.message || 'unknown error'
        }`,
      )
      try {
        recordFn.call(instance, payload)
        return
      } catch (retryError) {
        clientLogger.warn(
          `FPTI ${type} failed: ${retryError?.message || 'unknown error'}`,
        )
        return
      }
    }
  }

  clientLogger.warn(`FPTI ${type} skipped: analytics method unavailable`)
}

function generateOptions(data) {
  const options = {}

  if (!data) {
    clientLogger.warn('data object is undefined')
    return options
  }

  if (data.component) {
    options.component = data.component
  }

  if (data.link) {
    options.link = data.link
  }
  options.page = data.page

  if (data.pageDetails) {
    options.pageDetails = data.pageDetails
  }

  if (data.applicationId) {
    options.applicationId = data.applicationId
  }

  if (data.message) {
    options.message = data.message
  }

  options.locale = serverData.locality ? serverData.locality.locale : undefined

  options.experimentation = serverData.serverFPTIData
    ? serverData.serverFPTIData
    : undefined

  if (data.error) {
    options.errorField = data.error
  }

  return options
}
function trackClick(fptiData) {
  const options = generateOptions(fptiData)
  const fpti = {}
  // set link name
  fpti.link = options.link

  // set page name
  fpti.pgrp = `main:merchant-lending:loanbuilder::${options.page}::`
  fpti.page = `main:merchant-lending:loanbuilder::${options.page}::`
  fpti.pglk = `main:merchant-lending:loanbuilder::${options.component}|${options.link}`
  fpti.pgln = `main:merchant-lending:loanbuilder::${options.component}:::|${options.link}`
  fpti.client_id = getApplicationTypeName()
  if (options.locale) {
    fpti.locale = options.locale
  } else {
    fpti.locale = undefined
  }

  if (options.applicationId) {
    fpti.applicationId = options.applicationId
  }

  fpti.status = undefined
  fpti.article_search_count = undefined
  fpti.article_search_query = undefined
  fpti.message = undefined

  // Setting Experimentation Data
  fpti.experiment_name = options.experimentation
    ? options.experimentation.experiment_name
    : undefined
  fpti.experimentation_treatment = options.experimentation
    ? options.experimentation.experimentation_treatment
    : undefined
  fpti.se = options.experimentation ? options.experimentation.se : undefined
  fpti.st = options.experimentation ? options.experimentation.st : undefined
  fpti.xe = options.experimentation ? options.experimentation.xe : undefined

  fpti.encrypted_customer_id = undefined
  fpti.article_experience = undefined
  fpti.article_doc_id = undefined
  fpti.aidrk = undefined
  fpti.article_document_title = undefined
  // clearing out error props in case they exist
  fpti.erpg = undefined
  fpti.erfd = undefined
  fpti.eccd = undefined

  // setting component
  fpti.component = 'creditloanbldrnodeweb'
  recordFpti('click', fpti)
}

function trackFormValidationClick(fptiData) {
  const options = generateOptions(fptiData)
  const fpti = {}
  // set link name
  fpti.link = options.link

  // set page name
  fpti.pgrp = `main:merchant-lending:loanbuilder::${options.page}::`
  fpti.page = `main:merchant-lending:loanbuilder::${options.page}::`
  fpti.pglk = `main:merchant-lending:loanbuilder::${options.component}|${options.link}`
  fpti.pgln = `main:merchant-lending:loanbuilder::${options.component}:::|${options.link}`
  fpti.client_id = getApplicationTypeName()
  if (options.locale) {
    fpti.locale = options.locale
  } else {
    fpti.locale = undefined
  }

  if (options.applicationId) {
    fpti.applicationId = options.applicationId
  }

  fpti.status = undefined
  fpti.article_search_count = undefined
  fpti.article_search_query = undefined
  fpti.message = options.message ? options.message : undefined

  // Setting Experimentation Data
  fpti.experiment_name = options.experimentation
    ? options.experimentation.experiment_name
    : undefined
  fpti.experimentation_treatment = options.experimentation
    ? options.experimentation.experimentation_treatment
    : undefined
  fpti.se = options.experimentation ? options.experimentation.se : undefined
  fpti.st = options.experimentation ? options.experimentation.st : undefined
  fpti.xe = options.experimentation ? options.experimentation.xe : undefined

  fpti.encrypted_customer_id = undefined
  fpti.article_experience = undefined
  fpti.article_doc_id = undefined
  fpti.aidrk = undefined
  fpti.article_document_title = undefined
  // clearing out error props in case they exist
  fpti.erpg = undefined
  fpti.erfd = undefined
  fpti.eccd = undefined
  // setting component
  fpti.component = 'creditloanbldrnodeweb'
  recordFpti('click', fpti)
}

function trackPage(fptiData) {
  const options = generateOptions(fptiData)
  const fpti = {}
  fpti.pgrp = `main:merchant-lending:loanbuilder::${options.page}::`
  fpti.page = `main:merchant-lending:loanbuilder::${options.page}::`
  fpti.client_id = getApplicationTypeName()
  if (options.link) {
    fpti.link = options.link
    fpti.pglk = `main:merchant-lending:loanbuilder::${options.page}|${options.link}`
    fpti.pgln = `main:merchant-lending:loanbuilder::${options.page}:::|${options.link}`
  } else {
    fpti.link = undefined
    fpti.pglk = undefined
    fpti.pgln = undefined
  }

  if (options.applicationId) {
    fpti.applicationId = options.applicationId
  }

  // clearing out error props in case they exist
  fpti.erpg = undefined
  fpti.erfd = undefined
  fpti.eccd = undefined
  fpti.aidrk = undefined
  fpti.message = undefined
  fpti.status = undefined
  fpti.article_doc_id = undefined

  if (options.locale) {
    fpti.locale = options.locale
  } else {
    fpti.locale = undefined
  }

  if (options.pageDetails) {
    fpti.page_details = options.pageDetails
  }

  // Setting Experimentation Data
  fpti.experiment_name = options.experimentation
    ? options.experimentation.experiment_name
    : undefined
  fpti.experimentation_treatment = options.experimentation
    ? options.experimentation.experimentation_treatment
    : undefined
  fpti.se = options.experimentation ? options.experimentation.se : undefined
  fpti.st = options.experimentation ? options.experimentation.st : undefined
  fpti.xe = options.experimentation ? options.experimentation.xe : undefined
  // setting component
  fpti.component = 'creditloanbldrnodeweb'
  recordFpti('impression', fpti)
}

function trackError(fptiData) {
  const options = generateOptions(fptiData)
  const fpti = {}
  // set link name
  if (options.link) {
    fpti.link = options.link
  }

  // set page name
  const pageDetails = options.pageDetails
  fpti.pgrp = pageDetails
    ? pageDetails.pageGroupName
    : `main:merchant-lending:loanbuilder::${options.page}::`
  fpti.page = pageDetails
    ? pageDetails.pageName
    : `main:merchant-lending:loanbuilder::${options.page}::`

  if (options.link && options.component) {
    fpti.pglk = `main:merchant-lending:loanbuilder::${options.component}|${options.link}`
    fpti.pgln = `main:merchant-lending:loanbuilder::${options.component}:::|${options.link}`
  }

  fpti.client_id = getApplicationTypeName()

  if (options.errorField) {
    fpti.erpg = options.errorField
    fpti.erfd = options.link
  }

  if (options.locale) {
    fpti.locale = options.locale
  } else {
    fpti.locale = undefined
  }

  if (options.applicationId) {
    fpti.applicationId = options.applicationId
  }

  // Setting Experimentation Data
  fpti.experiment_name = options.experimentation
    ? options.experimentation.experiment_name
    : undefined
  fpti.experimentation_treatment = options.experimentation
    ? options.experimentation.experimentation_treatment
    : undefined
  fpti.se = options.experimentation ? options.experimentation.se : undefined
  fpti.st = options.experimentation ? options.experimentation.st : undefined
  fpti.xe = options.experimentation ? options.experimentation.xe : undefined
  // setting component
  fpti.component = 'creditloanbldrnodeweb'
  recordFpti('impression', fpti)
}

export {
  trackClick,
  trackFormValidationClick,
  trackPage,
  trackError,
  generateOptions,
}
